import {ModelDTO} from "./modelDTO.interface";
import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface DerivDTO extends BaseIntDTO {
  modelId: number;
  derivName: string;
  model: ModelDTO;
}
